export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "吃瓜爆网的爆款视频内容从哪里来？",
    a: "吃瓜爆网由内容团队在全网公开渠道中，依据热度、创意与传播度进行人工筛选和二次编辑，聚焦出圈现场、高能名场面、神反转与治愈日常等主题，把真正值得看的内容按专题精选呈现给大家。",
  },
  {
    q: "视频多久更新一次？为什么推荐会持续变化？",
    a: "内容团队保持每日精选、实时跟进出圈趋势。随着新热点出现，热门榜单与专题推荐会不断轮换，确保你刷到的永远是最新、最有看点的内容，避免陈旧素材占据版面。",
  },
  {
    q: "我可以投稿或推荐自己发现的宝藏视频吗？",
    a: "当然可以。欢迎通过页面底部的联系方式把你想分享的出圈视频、名场面或脑洞创意告诉我们，经过内容团队审核后会统一收录进对应专题，让更多人看到。",
  },
  {
    q: "站内内容是否尊重原作者版权？",
    a: "吃瓜爆网坚持内容原则与合规底线，所有内容以推荐、盘点与点评形式呈现，注明来源方向；涉及版权争议的内容会在第一时间下线。我们鼓励大家支持原创作者的完整作品。",
  },
  {
    q: "移动端和电脑端都能正常浏览吗？",
    a: "可以。吃瓜爆网采用响应式设计，在手机、平板和电脑上都会自动适配布局，顶部菜单在移动端可展开收起，分类筛选与回到顶部等功能均可正常使用。",
  },
  {
    q: "如何及时收到最热门的内容推送？",
    a: "可以把吃瓜爆网加入浏览器收藏，或定期回来看首页的热门速递与本周热议。如果你有常刷的内容方向，欢迎留言告诉我们，我们会优先补充对应专题。",
  },
];

export const siteStats = [
  { key: "s1", label: "累计盘点看点", value: "8000+" },
  { key: "s2", label: "每日精选更新", value: "50+" },
  { key: "s3", label: "覆盖热门专题", value: "120+" },
  { key: "s4", label: "全网观看热度", value: "数亿" },
];

export const valuesList = [
  {
    title: "真实热度优先",
    desc: "只挑真正被大家疯传、有讨论度的内容，用数据而非感觉来筛选看点。",
    icon: "ri-fire-line",
  },
  {
    title: "尊重创作版权",
    desc: "坚持推荐与点评的定位，标注内容来源方向，涉及版权问题第一时间处理。",
    icon: "ri-copyright-line",
  },
  {
    title: "多元有趣不低俗",
    desc: "既有高能反转也有治愈日常，内容积极向上，拒绝博眼球的低俗炒作。",
    icon: "ri-emotion-laugh-line",
  },
  {
    title: "持续新鲜更新",
    desc: "内容团队实时跟进出圈趋势，每日精选上新的专题与榜单，让看点保持鲜活。",
    icon: "ri-refresh-line",
  },
];